import React, { useEffect } from 'react';
import {useDispatch, useSelector} from 'react-redux';
import styled from 'styled-components';
import {currentResource, labels} from '../../../util/utils';
import utilityfunctions from '../../../util/utilityfunctions';
import {setUnsavedDataModalState,} from '../../../actions/AdminUser/UnsavedDataAction';
import CommonAdminTable from '../Common/CommonAdminTable';
import MotifToggleSwitch from '@ey/motif-react-wrapper/ToggleSwitch';
import useDetailsSelector from '../Common/Hooks/GetDetailsHook';

function MembersTable({ currentOwners, updateOwners, addedMembers, currentProject}) {
	const dispatch = useDispatch();

	const membersInfo = useDetailsSelector('users').concat(addedMembers);
	const membersGroups = useDetailsSelector('groups');

	const updateCurrentOwnerState = (user) => {
		console.log(membersInfo)
		updateOwners(prevState => {
			let prev = {...prevState}
			if(!prev.hasOwnProperty(user.userId)) {
				prev[user.userId] = !user.isProjectOwner
				return prev
			} else {
				delete prev[user.userId]
				return prev
			}
		})
	}

	useEffect(() => {
		if(_.size(currentOwners) === 1) {
			dispatch(setUnsavedDataModalState('projectOwners', true))
		} else if (_.size(currentOwners) == 0) {
			dispatch(setUnsavedDataModalState('projectOwners', false))
		}	
	}, [currentOwners])

	const membersTableConfig = {
		columns: [
			{
				label: labels.nameLabel,
				sortable: true,
				propName: 'firstName',
				width: '25%',
				customCellRender: (item) => {
					return (
						<span title={`${item.firstName} ${item.lastName}`} className="view-cell ellipsis">
							{item.firstName + ' ' + item.lastName}
						</span>
					);
				}
			},
			{
				label: labels.projectOwnerLabel,
				sortable: false,
				propName: 'connectedGroups',
				width: '15%',
				customCellRender: (item) => {
					const thisuser = {userId: item.userId, isProjectOwner: item.isProjectOwner}
					return (
						<StyledToggleWrap>
							<MotifToggleSwitch
								id={`${item.userId} toggle-${'show-details'}`}
								className={item.isProjectOwner ? 'show-details-toggleon' : 'show-details-toggleoff'}
								checked={currentOwners.hasOwnProperty(item.userId) ? currentOwners[item.userId] : item.isProjectOwner}
								disabled={currentProject && (currentProject[0]?.status.toLowerCase() === 'draft' || currentProject[0]?.status.toLowerCase() === 'delete')? true:false}
								onChange={() => {updateCurrentOwnerState(item)}}
								offLabel={labels.no}
								onLabel={labels.yes}
								title={''}
							/>
						</StyledToggleWrap>
					);
				}
			},
			{
				label: labels.typeLabel,
				sortable: false,
				width: '15%',
				propName: 'userType',
				customCellRender: (item) => {
					return item.userType === 'Member' ? (
						<span title={labels.internal} className="view-cell ellipsis">
							{labels.internal}
						</span>
					) : (
						<span title={labels.external} className="view-cell ellipsis">
							{labels.external}
						</span>
					);
				}
			},
			{
				label: labels.entitiesLabels,
				sortable: false,
				propName: 'connectedEntities',
				width: '20%',
				customCellRender: (item) => {
					let result = entityList(item);

					return result;
				}
			}
		],
		tableClassName: 'tabs-proj-table members-table',
		items: membersInfo.filter(m=>m.isProjectOwner),
		sortConfig: {
			sortBy: 'firstName',
			sortIsAscending: true
		}
	};

	const groupsList = (item) => {
		const groups = [...item.connectedGroups].map((v) => {
			return `${v.groupName}`;
		});
		const orderedGroups = groups.sort((a, b) => a.localeCompare(b));
		return (
			<StyledViewCell>
				{orderedGroups.length === 0 ? (
					<span className="ellipsis">{''}</span>
				) : (
					orderedGroups.map((v, index) => {
						return (
							<span title={v} className="view-cell ellipsis">
								{v}
							</span>
						);
					})
				)}
			</StyledViewCell>
		);
	};

	const entityList = (item) => {
		const groups = item.connectedGroups.map((v) => {
			return v.groupId;
		});
		let entityNames = [];
		groups.map((gid) => {
			let group = _.find(membersGroups, (g) => {
				if (g.accessGroupId === gid) return g;
			});
			if(group && !_.isEmpty(group.connectedEntities)){
			for (let ent of group?.connectedEntities) {
				entityNames.push(ent.entityName);
			}
		}
		});

		let newEntities = [...new Set(entityNames)];

		newEntities = newEntities.sort((a, b) => a.localeCompare(b));
		return (
			<StyledViewCell>
				{newEntities.length === 0 ? (
					<span className="ellipsis">{''}</span>
				) : (
					newEntities.map((v, index) => {
						return (
							<span title={v} className="view-cell ellipsis">
								{v}
							</span>
						);
					})
				)}
			</StyledViewCell>
		);
	};

	return (
		<StyledMemberTableSection>
			<CommonAdminTable config={membersTableConfig} />
		</StyledMemberTableSection>
	);
}

export default MembersTable;

const StyledMemberTableSection = styled.section`
	.table-row {
		align-items: flex-start;
	}
`;

const StyledToggleWrap = styled.section`
	margin-top: 1.5rem;
	margin-bottom: 1rem;
	.motif-toggle-switch-off-text,
	.motif-toggle-switch-on-text {
		font-size: 1.2rem;
		display: inline-block;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

const StyledViewCell = styled.section`
	display: flex;
	flex-direction: column;
	width: 90%;
	margin-top: 1rem;
	margin-bottom: 1rem;

	.view-cell {
		line-height: 3rem;
	}
`;
